import { render, staticRenderFns } from "./WdUpdateModal.vue?vue&type=template&id=43a72162&"
import script from "./WdUpdateModal.vue?vue&type=script&lang=js&"
export * from "./WdUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports